import React, { useState } from 'react';
import { Modal, inputCls, selectCls, labelCls } from './shared';
import { MOCK_LEADS } from './mockData';

export function NewLeadModal({ modal, closeModal, showToast }) {
  const [name, setName] = useState('');
  const [company, setCompany] = useState('');
  const [designation, setDesignation] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [notes, setNotes] = useState('');

  if (modal !== 'new-lead') return null;

  const submit = e => {
    e.preventDefault();
    showToast('Lead created successfully');
    closeModal();
    setName(''); setCompany(''); setDesignation(''); setPhone(''); setEmail(''); setNotes('');
  };

  return (
    <Modal isOpen onClose={closeModal} title="Create New Lead">
      <form onSubmit={submit} className="space-y-5">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className={labelCls}>Full Name</label>
            <input 
              value={name} 
              onChange={e => setName(e.target.value)} 
              className={inputCls} 
              placeholder="e.g. Ganesh Kumar" 
              required 
            />
          </div>
          <div>
            <label className={labelCls}>Company</label>
            <input 
              value={company} 
              onChange={e => setCompany(e.target.value)} 
              className={inputCls} 
              placeholder="e.g. Adani Group" 
              required 
            />
          </div>
        </div>
        
        <div>
          <label className={labelCls}>Designation</label>
          <input 
            value={designation} 
            onChange={e => setDesignation(e.target.value)} 
            className={inputCls} 
            placeholder="e.g. VP Operations" 
          />
        </div>
        
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className={labelCls}>Phone</label>
            <input 
              value={phone} 
              onChange={e => setPhone(e.target.value)} 
              className={inputCls} 
              placeholder="+91 98765 43210" 
            />
          </div>
          <div>
            <label className={labelCls}>Email</label>
            <input 
              type="email" 
              value={email} 
              onChange={e => setEmail(e.target.value)} 
              className={inputCls} 
              placeholder="name@company.com" 
            />
          </div>
        </div>
        
        <div>
          <label className={labelCls}>Notes</label>
          <textarea 
            value={notes} 
            onChange={e => setNotes(e.target.value)} 
            className={inputCls} 
            rows={3} 
            placeholder="Additional context…" 
          />
        </div>
        
        <div className="flex justify-end gap-3 pt-3 border-t border-[var(--adani-border)]">
          <button 
            type="button" 
            onClick={closeModal} 
            className="btn-secondary"
          >
            Cancel
          </button>
          <button 
            type="submit" 
            className="btn-primary"
          >
            Create Lead
          </button>
        </div>
      </form>
    </Modal>
  );
}

export function LinkLeadModal({ modal, closeModal, showToast }) {
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(null);

  if (modal !== 'link-lead') return null;

  const results = MOCK_LEADS.filter(l => {
    if (!search) return true;
    const q = search.toLowerCase();
    return l.name.toLowerCase().includes(q) || l.company.toLowerCase().includes(q);
  });

  const link = () => {
    if (selected) { 
      showToast(`Linked to ${selected.name}`); 
      closeModal(); 
      setSelected(null); 
      setSearch(''); 
    }
  };

  return (
    <Modal isOpen onClose={closeModal} title="Link to Existing Lead">
      <div className="space-y-5">
        <div className="relative">
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--adani-text-tertiary)]">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="M21 21l-4.35-4.35"/>
            </svg>
          </div>
          <input 
            value={search} 
            onChange={e => setSearch(e.target.value)} 
            className={`${inputCls} pl-10`} 
            placeholder="Search by name or company…" 
          />
        </div>
        
        <div className="max-h-64 overflow-y-auto rounded-xl border border-[var(--adani-border)] bg-white/50">
          {results.map(l => (
            <button 
              key={l.id} 
              onClick={() => setSelected(l)} 
              className={`flex w-full cursor-pointer items-center gap-3 px-4 py-3.5 text-left text-sm border-b border-[var(--adani-border)] last:border-0 transition-all ${
                selected?.id === l.id 
                  ? 'bg-[var(--adani-primary)]/8' 
                  : 'hover:bg-black/[0.02]'
              }`}
            >
              <div className="avatar avatar-md avatar-primary">
                {l.name.split(' ').map(n => n[0]).join('')}
              </div>
              <div className="min-w-0 flex-1">
                <p className="font-medium text-[var(--adani-text-primary)] truncate">{l.name}</p>
                <p className="text-xs text-[var(--adani-text-tertiary)] truncate">{l.designation} · {l.company}</p>
              </div>
              {selected?.id === l.id && (
                <div className="flex h-6 w-6 items-center justify-center rounded-full bg-[var(--adani-primary)] shrink-0">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                    <path d="M20 6L9 17l-5-5"/>
                  </svg>
                </div>
              )}
            </button>
          ))}
          {results.length === 0 && (
            <div className="empty-state py-8">
              <p className="empty-state-text">No leads found</p>
            </div>
          )}
        </div>
        
        <div className="flex justify-end gap-3 pt-3 border-t border-[var(--adani-border)]">
          <button 
            type="button" 
            onClick={closeModal} 
            className="btn-secondary"
          >
            Cancel
          </button>
          <button 
            onClick={link} 
            disabled={!selected} 
            className="btn-primary"
          >
            Link Lead
          </button>
        </div>
      </div>
    </Modal>
  );
}
